<template>
  <div>
    <t-form labelWidth="90px">
      <t-form-item label="边框">
        <t-switch v-model="attribute.bordered" :label="['显示', '不显示']" size="small" />
      </t-form-item>
      <t-form-item label="分页">
        <t-switch v-model="attribute.pageShow" :label="['显示', '不显示']" size="small" />
      </t-form-item>
      <t-form-item label="显示序号">
        <t-switch v-model="attribute.showIndex" :label="['显示', '不显示']" size="small" />
      </t-form-item>
      <t-form-item label="对齐方式">
        <t-select v-model="attribute.textAlign" size="small">
          <t-option label="靠左" value="left" />
          <t-option label="居中" value="center" />
          <t-option label="靠右" value="right" />
        </t-select>
      </t-form-item>
      <t-form-item label="行高">
        <t-input-number :min="13" :max="250" v-model="attribute.lineHeight" size="small" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="表头行高">
        <t-input-number :min="13" :max="250" v-model="attribute.headLineHeight" size="small" :decimal-places="0" />
      </t-form-item>

      <t-form-item label="表头背景">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.theadBg" size="small"
          enableAlpha />
      </t-form-item>

      <t-form-item label="表头字体">
        <t-select v-model="attribute.headFontFamily" size="small">
          <t-option v-for="(item, index) in textFamilyList" :key="index + item.label" :label="item.label"
            :value="item.value" />
        </t-select>
      </t-form-item>
      <t-form-item label="表头字色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.theadColor" size="small" />
      </t-form-item>
      <t-form-item label="表头字号">
        <t-input-number v-model="attribute.theadSize" size="small" :min="12" :max="150" />
      </t-form-item>
      <t-form-item label="表格字色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.tbodyColor" size="small" />
      </t-form-item>
      <t-form-item label="表格字号">
        <t-input-number v-model="attribute.tbodySize" size="small" :min="12" :max="150" />
      </t-form-item>
      <t-form-item label="奇数行背景">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" @change="ev => onChangeBodyColor(ev, 'oddRowBg')"
          v-model="attribute.oddRowBg" size="small" enableAlpha />
      </t-form-item>
      <t-form-item label="偶数行背景">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" @change="ev => onChangeBodyColor(ev, 'evenRowBg')"
          v-model="attribute.evenRowBg" size="small" enableAlpha />
      </t-form-item>
      <t-form-item label="分页字体颜色">
        <t-color-picker :colorModes="['monochrome']" format="RGBA"
          @change="ev => onChangeBodyColor(ev, 'pageNumberColor')" v-model="attribute.pageNumberColor" size="small"
          enableAlpha />
      </t-form-item>

      <t-form-item label="默认页容量">
        <t-select v-model="attribute.pageSize" size="small">
          <t-option label="5" :value="5" />
          <t-option label="10" :value="10" />
          <t-option label="20" :value="20" />
          <t-option label="50" :value="50" />
        </t-select>
      </t-form-item>


      <div style="color: #fff;text-indent: 1em">
        表格列设置：<t-button size="small" theme="primary" @click="addCol">新增列</t-button>
      </div>
      <t-table style="font-size: 12px;margin-top: 10px;" size="small" rowKey="id" :data="attribute.columns"
        :hover="true" :columns="columns" :bordered="true" @row-click="editRow" />
      <e-collapse title="选中行样式" :expand="false">
        <t-form-item label="边框颜色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.chooseColor" size="small"
            enableAlpha />
        </t-form-item>
        <!-- <t-form-item label="行背景">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.chooseRowBg" size="small"
            enableAlpha />
        </t-form-item> -->
      </e-collapse>
    </t-form>
    <t-dialog :header="currentRow.id ? '编辑' : '添加'" v-model:visible="modelShow" :onConfirm="confirmRow"
      :draggable="true">
      <t-form>
        <t-form-item label="字段标识">
          <t-select filterable v-model="currentRow.colKey">
            <t-option v-for="item in dataSetData" :key="item.value" :label="item.label" :value="item.value" />
          </t-select>
          <!-- <t-input v-model="currentRow.colKey"/> -->
        </t-form-item>
        <t-form-item label="字段名">
          <t-input v-model="currentRow.title" />
        </t-form-item>
        <t-form-item label="字段类型">
          <t-radio-group v-model="currentRow.type">
            <t-radio-button value="text">文本</t-radio-button>
            <t-radio-button value="img">图片</t-radio-button>
            <t-radio-button value="btn">按钮</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="字体">
          <t-select v-model="currentRow.textFamily" size="small">
            <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value" />
          </t-select>
        </t-form-item>
        <t-form-item label="加粗">
          <t-radio-group v-model="currentRow.fontWeight" size="small">
            <t-radio-button value="lighter">更细</t-radio-button>
            <t-radio-button value="normal">正常</t-radio-button>
            <t-radio-button value="bold">加粗</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="文本颜色选项">
          <t-radio-group v-model="currentRow.enableGradual" size="small">
            <t-radio-button :value="1">纯色</t-radio-button>
            <t-radio-button :value="2">渐变从左到右</t-radio-button>
            <t-radio-button :value="3">渐变从上到下</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="文本对齐方式">
          <t-select v-model="currentRow.textAlign" size="small">
            <t-option label="靠左" value="left" />
            <t-option label="居中" value="center" />
            <t-option label="靠右" value="right" />
          </t-select>
        </t-form-item>
        <t-form-item label="文本" v-if="currentRow.enableGradual == 1">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="currentRow.textColor" size="small" />
        </t-form-item>
        <t-form-item label="渐变" v-if="currentRow.enableGradual == 2 || currentRow.enableGradual == 3">
          <e-color-group v-model="currentRow.gradualColor" :min="2" :absolute="true" />
        </t-form-item>
        <t-form-item label="宽度">
          <t-input-number v-model="currentRow.width" :min="0" :max="1000" :decimal-places="0" />
        </t-form-item>
        <t-form-item v-show="currentRow.id">
          <t-button theme="danger" @click="delCol">删除此列</t-button>
        </t-form-item>

      </t-form>
    </t-dialog>
  </div>
</template>

<script>
import { getDetailApi } from "@/api/dataset/dataset-sql";
import { executeSelectKey } from "@/api/sql-execute-api";
export default {
  name: "cpt-table-option",
  props: {
    attribute: Object, cptDataForm: Object,
    currentCpt: Object,
  },
  data() {
    return {
      columns: [
        { colKey: 'colKey', title: '字段标识' },
        { colKey: 'title', title: '字段名' },
        { colKey: 'width', title: '宽度' }
      ],
      modelShow: false,
      currentIndex: 0,
      currentRow: {},
      dataSetData: [],
      textFamilyList: require('@/assets/font/font-list')
    }
  },
  watch: {
    'cptDataForm': {
      handler(obj) {
        console.log(obj, 'obj')
      },
      deep: true,
    },
  },
  mounted() {
    if (this.cptDataForm.dataSource == '4') {
      this.executeSelectFun(this.cptDataForm);
    } else if (this.cptDataForm.dataSource == '1') {
      const obj = JSON.parse(this.cptDataForm.dataText)[0];
      for (let key in obj) {
        // 将每个键和对应的值封装成一个新的对象，并添加到数组中
        this.dataSetData.push({ label: key, value: key });
      }
      console.log(this.dataSetData, 'dataSetData')
    }

    if (this.attribute.showIndex == undefined) {
      this.attribute.showIndex = true
    }
  },
  methods: {
    executeSelectFun(cptDataForm) {
      const that = this;

      getDetailApi(cptDataForm.datasetId)
        .then((res) => {
          let iptstr = res.data.sqlText;

          if (!iptstr) {
            // this.$message.Message.error("SQL不能为空");
            return [];
          }

          // 返回 executeSelectKey 的 Promise 并直接在其 then 中处理结果
          return executeSelectKey({
            sql: iptstr,
            datasourceId: res.data.datasourceId,
            isArray: true,
          });
        })
        .then((result) => {
          console.log(result, "result");
          // 直接根据 result 数据结构来决定是否赋值以及如何赋值
          if (result && result.data) {
            result.data.forEach(item => {
              // 将每个对象的COLUMN_NAME属性作为label和value封装成一个新的对象，并添加到数组中
              that.dataSetData.push({ label: item.COLUMN_NAME, value: item.COLUMN_NAME });
              console.log(that.dataSetData, 'dataSetData-----')
            });
          } else {
            that.dataSetData = [];
          }
        })
        .catch((error) => {
          // this.$message.error("执行查询时发生错误:", error);
          // this.$message.error("查询数据失败，请稍后重试");
          that.dataSetData = []; // 当出现错误时，清空或设置为空数组
        });
    },
    confirmRow() {
      if (!this.currentRow.colKey || !this.currentRow.title) {
        this.$message.error('请输入字段标识或字段名称');
        return;
      }
      if (this.currentRow.id) {
        this.attribute.columns.splice(this.currentIndex, 1, JSON.parse(JSON.stringify(this.currentRow)));
      } else {
        const id = new Date().getTime();
        this.attribute.columns.push(Object.assign(this.currentRow, { id: id }));
      }
      this.modelShow = false
    },
    addCol() {
      this.currentRow = { width: 0 };
      this.modelShow = true
    },
    editRow(row) {
      this.currentRow = JSON.parse(JSON.stringify(row.row));
      this.currentIndex = row.index;
      this.modelShow = true
    },
    delCol() {
      this.attribute.columns.splice(this.currentIndex, 1);
      this.modelShow = false
    },
    onChangeBodyColor(color, field) {
      this.attribute[field] = color
    }
  }
}
</script>

<style scoped></style>
